import { type CustomSeriesRenderItemParams } from 'echarts';
import { util } from 'echarts/core';
import type Chart from '../../../core/StandardChart';
import type { DvMarkerOption, Option } from '../../../core/option';
import { type DvMarkerData } from './type';
import * as graphicHandle from './graphic';
import { isObject } from '../../../util/utils';
import { defaultData } from './defaultOption';

// 主要是把用户的配置项转换成echarts配置项
export class DvMarkerModel {
  // 图表实例
  protected _chart: Chart;

  // series序号
  protected _index: number;

  // series关联的option
  protected _option: Option;

  // standard-chart中的series的option 类型为用户所接受的option配置项对象
  protected _series: DvMarkerOption;

  // echarts中的series的option 类型为echarts所接受的option配置项

  // series对应的data
  protected _data: DvMarkerData;

  constructor(chart: Chart, seriesOption: DvMarkerOption, option: Option) {
    this._chart = chart;
    this._option = option;
    // this._prepareSeries(seriesOption);
    this._series = seriesOption;
    this._data = this._prepareData(seriesOption.data, this._series);
  }

  /**
   *  准备用户数据
   * @fileoverview 1. 把用户的数据和默认数据模板合并 2. 把series下的style合并到data下
   * @todo 混合标记场景中，合并样式应当根据单个数据对应的标记类型获取默样式，并合并。
   * @param data
   * @returns
   */
  protected _prepareData(data: DvMarkerData, series: DvMarkerOption): DvMarkerData {
    let preparedData = data;
    const defaultData = {
      markerType: series.dvMarkType,
      weight: 1
    };

    preparedData.forEach(item => {
      // 与模板数据合并
      util.merge(item, defaultData);
      // 与series中的style合并
      if (isObject(series.dvItemStyle)) {
        const itemStyle = util.clone(series.dvItemStyle);
        item.itemStyle = util.merge(item.itemStyle || {}, itemStyle);
      }
    });
    preparedData = preparedData.sort((a, b) => a.value[0] - b.value[0]);
    return preparedData;
  }

  protected _renderItemHandle(): void {
    this._series.renderItem = (params: CustomSeriesRenderItemParams, api) => {
      // 需要 x, y, 对应标记类型的数据，标记类型，动画配置， 交互
      // 都需要data结合series配置项提供

      // 获取每个item的markerType
      const { dataIndex } = params;
      const data = this._data[dataIndex];
      const { markerType } = data;
      return graphicHandle[markerType](data, this._series, api, params, dataIndex);
    };
  }

  protected _parseSeries(): void {
    // this._dataHandle();
    // 合并renderItem到ESeries
    this._renderItemHandle();
  }

  protected _parse(): void {
    this._parseSeries();
  }

  init(): void {
    this._parse();
  }
}
